// Which saved recipes are on the grocery list (this device).
import { useEffect, useState } from 'preact/hooks';
import { load, save, KEYS } from './storage';

const listeners = new Set<() => void>();

export function groceryIDs(): number[] {
  const ids = load<number[]>(KEYS.grocery, []);
  return Array.isArray(ids) ? ids.filter((n) => Number.isInteger(n) && n > 0) : [];
}
export function setGroceryIDs(ids: number[]) {
  save(KEYS.grocery, [...new Set(ids)].slice(0, 30));
  listeners.forEach((f) => f());
}
export function inGrocery(id: number) { return groceryIDs().includes(id); }
export function toggleGrocery(id: number): boolean {
  const ids = groceryIDs();
  const on = !ids.includes(id);
  setGroceryIDs(on ? [...ids, id] : ids.filter((x) => x !== id));
  return on;
}

/** How many recipes are on the list, kept current as recipes are added or removed. */
export function useGroceryCount(): number {
  const [n, setN] = useState(() => groceryIDs().length);
  useEffect(() => {
    const f = () => setN(groceryIDs().length);
    listeners.add(f);
    return () => { listeners.delete(f); };
  }, []);
  return n;
}
